import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from "@/views/Dashboard.vue";
import Login from '@/views/Login.vue';

import Notifications from '@/views/notifications/Notifications.vue'


import Doctors from "@/views/doctors/Doctors.vue";
import DoctorDetails from '@/views/doctors/DoctorDetails.vue'
import Patients from "@/views/patients/Patients.vue";
import Patient from '@/views/patients/Patient.vue'
import Incidents from "@/views/incidents/Incidents.vue";
import Insurance from "@/views/insurance/Insurance.vue";
import InsuranceDetails from '@/views/insurance/InsuranceDetails.vue'
import Healthcare from "@/views/healthcare/Healthcare.vue";
import Ambulance from "@/views/ambulance/Ambulance.vue";
import SelectedAmbulance from "@/views/ambulance/SelectedAmbulance.vue";
import Invoices from "@/views/invoices/Invoices.vue";
import Reports from '@/views/reports/Reports.vue'
import List from '@/views/reports/List.vue'
import Present from '@/views/reports/Present.vue'
import PatientCalls from '@/views/reports/PatientCalls.vue'
import DoctorCalls from '@/views/reports/DoctorCalls.vue'
import Calls from '@/views/reports/Calls.vue';
import store from '../store/index'
Vue.use(VueRouter)

const notLogged = (to, from, next) => {
  if (!store.getters.isAuth) {
    next('/login')
  } else {
    next()
  }
}

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: notLogged
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters.isAuth) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
    beforeEnter: notLogged
  },
  {
    path: '/doctors',
    name: 'doctors',
    component: Doctors,
    beforeEnter: notLogged
  },
  {
    path: '/doctors/:id',
    name: 'doctor',
    component: DoctorDetails,
    beforeEnter: notLogged
  },
  {
    path: '/incidents',
    name: 'incidents',
    component: Incidents,
    beforeEnter: notLogged
  },
  {
    path: '/patients',
    name: 'patients',
    component: Patients,
    beforeEnter: notLogged
  },
  {
    path: '/patients/patient/:id',
    name: 'patient',
    component: Patient,
    beforeEnter: notLogged
  },
  {
    path: '/insurances',
    name: 'insurances',
    component: Insurance,
    beforeEnter: notLogged
  },
  {
    path: '/insurances/insurance/:id',
    name: 'insurance',
    component: InsuranceDetails,
    beforeEnter: notLogged
  },
  {
    path: '/healthcare',
    name: 'healthcare',
    component: Healthcare,
    beforeEnter: notLogged
  },
  {
    path: '/ambulance',
    name: 'ambulance',
    component: Ambulance,
    beforeEnter: notLogged
  },
  {
    path: '/ambulance/:id',
    name: 'selectedAmbulance',
    component: SelectedAmbulance,
    beforeEnter: notLogged
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: Invoices,
    beforeEnter: notLogged
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    beforeEnter:notLogged,
    children: [
      {
        path: 'list',
        name: 'list',
        component: List
      },
      {
        path: 'present',
        name: 'present',
        component: Present
      },
      {
        path: 'patient-calls/:dateFrom?/:dateTo?/:numCalls?',
        name: 'patientCalls',
        component: PatientCalls
      },
      {
        path: 'doctor-calls/:dateFrom?/:dateTo?/:numCalls?',
        name: 'doctorCalls',
        component: DoctorCalls
      },
      {
        path: 'calls',
        name: 'calls',
        component: Calls
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
